import { Link } from "react-router-dom";
import { Printer, ArrowLeft } from "lucide-react";
import { IMAGES } from "../lib/api";

export default function QRMenuPage() {
  const menuUrl = `${window.location.origin}/la-carte`;
  const qrSrc = `${process.env.REACT_APP_BACKEND_URL}/api/qrcode?data=${encodeURIComponent(menuUrl)}`;

  return (
    <div className="min-h-screen bg-white text-black flex flex-col items-center justify-center px-6 py-16" data-testid="qr-menu-page">
      <img src={IMAGES.logo} alt="Italian Club" className="h-28 w-28 object-contain mb-6" />
      <h1 className="font-serif-elegant text-4xl font-bold text-[#8a6d1d] text-center">Italian Club</h1>
      <p className="text-sm tracking-[0.3em] uppercase text-gray-500 mt-2">Bar · Restaurant · Live Music</p>
      <div className="tricolore mt-4"><span /><span style={{ background: "#ddd" }} /><span /></div>
      <div className="border-4 border-[#D4AF37] rounded-2xl p-6 mt-10 bg-white">
        <img src={qrSrc} alt="QR Code du menu" className="w-64 h-64" data-testid="qr-code-image" />
      </div>
      <p className="font-serif-elegant text-2xl mt-8 text-center">Scannez pour découvrir notre menu</p>
      <p className="text-sm text-gray-500 mt-2">{menuUrl}</p>
      <div className="flex gap-4 mt-10 no-print">
        <button onClick={() => window.print()} data-testid="qr-print-btn" className="btn-gold">
          <Printer size={17} /> Imprimer
        </button>
        <Link to="/la-carte" data-testid="qr-back-btn" className="btn-outline-gold !text-[#8a6d1d] !border-[#D4AF37]">
          <ArrowLeft size={17} /> Retour au menu
        </Link>
      </div>
    </div>
  );
}
